export const GROUP_MEMBER_ROLE = 'member'
export const GROUP_ADMIN_ROLE = 'admin'

export const ORG_INVITES_PAGE_TYPE = 'organizationInvitations'
export const ORG_MEMBERS_PAGE_TYPE = 'organizationMemberships'
export const ORG_MIGRATIONS_PAGE_TYPE = 'organizationMigrations'

export const SORT_USER_GROUP_NAME = 'name'
export const SORT_USER_GROUP_EMAIL = 'email'
export const SORT_USER_GROUP_ADMIN = 'user_group_admin'
export const SORT_USER_GROUP_MEMBER = 'user_group_member'
export const SORT_USER_GROUP_CREATED_AT = 'created_at'
export const SORT_USER_GROUP_LAST_SENT_AT = 'last_sent_at'
